// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2MJ2C","title":"ClientCherryInfo_title__1bWx9","itemText":"ClientCherryInfo_itemText__GfkCo"};